import seoConfig from '../config/seoConfig';

export function applyDomainSEO() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const baseHost = window.location.hostname;
  const port = window.location.port ? `:${window.location.port}` : '';

  const hostKey =
    process.env.NODE_ENV === 'development' ? `${baseHost}${port}` : baseHost;

  const config = seoConfig[hostKey];

  if (!config) return;

  const publicUrl = process.env.PUBLIC_URL || '';
  const logoHref = config.logo ? `${publicUrl}${config.logo}` : null;

  document.title = config.title;

  const description = document.querySelector("meta[name='description']");
  if (description) description.setAttribute('content', config.description);

  if (logoHref) {
    const faviconSelectors = [
      "link[rel='icon']",
      "link[rel='shortcut icon']",
    ];

    faviconSelectors.forEach((selector) => {
      const linkEl = document.querySelector(selector);
      if (linkEl) {
        linkEl.setAttribute('href', logoHref);
        linkEl.setAttribute('type', 'image/x-icon');
      }
    });

    const appleTouch = document.querySelector("link[rel='apple-touch-icon']");
    if (appleTouch) {
      appleTouch.setAttribute('href', logoHref);
    }
  }
}

